import { render, staticRenderFns } from "./ResourceSelector.vue?vue&type=template&id=3a5bed9b"
import script from "./ResourceSelector.vue?vue&type=script&lang=js"
export * from "./ResourceSelector.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ResourceSelector.vue?vue&type=style&index=1&id=3a5bed9b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports